import LogicaAPI from "./logicaapi";

class Product extends LogicaAPI {
  async productById({ id }) {
    const params = {
      ...this.dsearchCommonParams,
      condition: {
        id,
        "values.adult_flag": false,
      },
    };
    const res = await this.get(`/api/v1/products/dsearch`, {
      params: {
        q: JSON.stringify(params),
      },
    });
    return res?.products?.[0];
  }

  // 本番環境だとrightのスキーマに画像が設定されていてLogicaAPIが500エラーになるので使わない
  // async productRight(id) {
  //   const res = await this.get(`/products/${id}/rights`);
  //   return res?.[0];
  // }
}

export default Product;
